"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;

var _Popup = _interopRequireDefault(require("./Popup"));

exports.default = _Popup.default;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/modules/Popup/index.js
// module id = 1511
// module chunks = 0